import { IEventCard } from '@interfaces'

export const normalizeSearchText = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

export const isLearningCard = (c: IEventCard) =>
  c.type === 'learning' ||
  (c.tagsTx || []).some((t) =>
    normalizeSearchText(String(t)).includes('learning')
  )

/** Öğrenme akışındaki çocuk / kid workshop kartları (Çocuk sekmesi) */
export const isChildLearningCard = (c: IEventCard): boolean => {
  const tagsNorm = (c.tagsTx || []).map((t) => normalizeSearchText(String(t)))
  const blob = normalizeSearchText(
    `${tagsNorm.join(' ')} ${c.title || ''} ${c.url || ''}`
  )
  if (tagsNorm.some((t) => t.includes('child') || t.includes('kid')))
    return true
  if (blob.includes('learning-kid')) return true
  if (blob.includes('kid-workshop')) return true
  if (blob.includes('cocuk')) return true
  return false
}

export const filterAdultLearningCards = (items: IEventCard[]) =>
  items.filter((c) => isLearningCard(c) && !isChildLearningCard(c))

export const filterChildLearningCards = (items: IEventCard[]) =>
  items.filter((c) => isLearningCard(c) && isChildLearningCard(c))

/** Güncel + gelecek sergileri birleştirir; en yüksek sourceId (en yeni) önce gelir. */
export const mergeMuseumProgramExhibitions = (
  current: IEventCard[] = [],
  future: IEventCard[] = []
): IEventCard[] =>
  [...current, ...future].sort(
    (a, b) => Number(b.id || 0) - Number(a.id || 0)
  )
